/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import { caseInsensitiveComparator } from '../../../Display/NDC/utility/tableHeads';
import { amountComparator } from '../../../Research/SuspendedChecks/components/gridComponents/tableHead';
import { numberAndTextComparator } from '../../client/Components/gridComponents/tableHead';

function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const monthNumber = Number.parseInt(date.substring(3, 5));
  const dayNumber = Number.parseInt(date.substring(0, 2));

  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}

function dateComparator(date1, date2) {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);

  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }

  return date1Number - date2Number;
}

export const tableHead = [
  {
    headerName: 'Actions',
    field: 'ccCommentsExist',
    filter: false,
    sortable: false,
    minWidth: 150,
    editable: false,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_1,
    resizable: false,
    cellRenderer: 'DeleteBoxRender',
    showCheckboxIcon: true,
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Start Date',
    field: 'startDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'StartDate',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Date',
    field: 'endDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'EndDate',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Plan Name',
    field: 'planName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_160,
    sortingOrder: ['asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellRenderer: 'PlanNameCustomComponent',
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    columnSpan: 3,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  // {
  //   headerName: '',
  //   field: '',
  //   removeColumn: true,
  //   minWidth: 1,
  //   resizable: false,
  //   editable: false,
  // },
  // {
  //   headerName: '',
  //   field: '',
  //   removeColumn: true,
  //   minWidth: 1,
  //   resizable: false,
  //   editable: false,
  // },
  {
    headerName: 'Rebate Program Code',
    field: 'rebateProgramCd',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: 175,
    cellRenderer: 'SelectionBoxRender',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_3,
    isNumber: true,
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },

    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Long Term Care Plan',
    field: 'ltcPlanInd',
    hideFilterIcon: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    editable: false,
    minWidth: 100,
    filter: false,
    cellRenderer: 'CheckBox',
    suppressMenu: false,
    sortable: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_1,
    showCheckboxIcon: true,
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Exclude Supp',
    field: 'excludeSuppInd',
    minWidth: 80,
    cellRenderer: 'CheckBox',
    wrapHeaderText: true,
    autoHeaderHeight: true,
    hideFilterIcon: true,
    editable: false,
    suppressMenu: false,
    sortable: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_1,
    showCheckboxIcon: true,
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
];
export const ClientHead = [
  {
    headerName: 'Client ID',
    field: 'clientId',
    editable: false,
    minWidth: 100,
    maxWidth: 250,
    cellStyle: {
      borderRightColor: '#D6D2D0',
      display: 'flex',
      alignItems: 'center',
    },
    filter: 'agTextColumnFilter',
    sort: 'asc',

    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',

      suppressAndOrCondition: true,

      buttons: ['reset'],

      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Client Name',
    field: 'clientName',
    editable: false,
    minWidth: 100,
    cellStyle: {
      borderRightColor: '#D6D2D0',
      display: 'flex',
      alignItems: 'center',
    },
    filter: 'agTextColumnFilter',
    sort: 'asc',
    resizable: false,
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const RebateProgramcellHead = [
  {
    headerName: 'Rebate Program CD',
    field: 'rebateProgramCd',
    editable: false,
    minWidth: 100,
    maxWidth: 250,
    cellStyle: { borderRightColor: '#D6D2D0' },
    filter: 'agTextColumnFilter',
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',

      suppressAndOrCondition: true,

      buttons: ['reset'],

      // closeOnApply: true,

      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Description',
    field: 'shortDescr',
    editable: false,
    minWidth: 100,
    sort: 'asc',
    resizable: false,
    cellStyle: { borderRightColor: '#D6D2D0' },
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: true,
      defaultOption: 'startsWith',
    },
  },
];
export const RebateProgramcellHeadForPopUP = [
  {
    headerName: 'Client ID',
    field: 'clientId',
    comparator: numberAndTextComparator,

    editable: false,
    minWidth: 150,
    maxWidth: 250,
    cellStyle: { borderRightColor: '#D6D2D0' },
    filter: 'agTextColumnFilter',
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',

      suppressAndOrCondition: true,

      buttons: ['reset'],

      // closeOnApply: true,

      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Group ID',
    field: 'groupId',
    comparator: numberAndTextComparator,

    editable: false,
    minWidth: 150,
    maxWidth: 250,
    cellStyle: { borderRightColor: '#D6D2D0' },
    filter: 'agTextColumnFilter',
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',

      suppressAndOrCondition: true,

      buttons: ['reset'],

      // closeOnApply: true,

      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Plan ID',
    field: 'planId',
    comparator: numberAndTextComparator,

    editable: false,
    minWidth: 150,
    maxWidth: 250,
    cellStyle: { borderRightColor: '#D6D2D0' },
    filter: 'agTextColumnFilter',
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',

      suppressAndOrCondition: true,

      buttons: ['reset'],

      // closeOnApply: true,

      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Plan Name',
    field: 'planName',
    editable: false,
    minWidth: 350,
    maxWidth: 350,
    filter: 'agTextColumnFilter',
    columnSpan: 3,
    resizable: false,
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',

      suppressAndOrCondition: true,

      buttons: ['reset'],

      // closeOnApply: true,

      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
];

export const popupField = [
  {
    headerName: 'Client ID',
    field: 'clientId',
    comparator: numberAndTextComparator,
    editable: false,
    minWidth: 80,
    maxWidth: 150,
    cellStyle: { borderRightColor: '#D6D2D0' },
    filter: 'agTextColumnFilter',
    sort: 'asc',
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Group ID',
    field: 'groupId',
    comparator: numberAndTextComparator,
    editable: false,
    minWidth: 80,
    maxWidth: 150,
    cellStyle: { borderRightColor: '#D6D2D0' },
    filter: 'agTextColumnFilter',
    sort: 'asc',
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const cellHead1 = [
  {
    headerName: 'Plan ID',
    field: 'planId',
    comparator: numberAndTextComparator,

    editable: false,
    minWidth: 80,
    maxWidth: 150,
    cellStyle: { borderRightColor: '#D6D2D0' },
    filter: 'agTextColumnFilter',
    sort: 'asc',
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',

      suppressAndOrCondition: true,

      buttons: ['reset'],

      // closeOnApply: true,

      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Plan Name',
    field: 'planName',
    editable: false,
    cellStyle: { borderRightColor: '#D6D2D0' },
    minWidth: 260,
    resizable: false,
    filter: 'agTextColumnFilter',
    comparator: caseInsensitiveComparator,
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
